module.exports = __webpack_public_path__ + "img/744.6ac016b3.jpg";